/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_Other_HintInputs */

const en_admin_questionnaire_editor_other_hint = /** @type {(inputs: Admin_Questionnaire_Editor_Other_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will add a text field where members can enter a custom answer.`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_Other_HintInputs) => LocalizedString} */
const de_admin_questionnaire_editor_other_hint = en_admin_questionnaire_editor_other_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Other_HintInputs) => LocalizedString} */
const es_admin_questionnaire_editor_other_hint = en_admin_questionnaire_editor_other_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Other_HintInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_other_hint = en_admin_questionnaire_editor_other_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Other_HintInputs) => LocalizedString} */
const it_admin_questionnaire_editor_other_hint = en_admin_questionnaire_editor_other_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Other_HintInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_other_hint = en_admin_questionnaire_editor_other_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Other_HintInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_other_hint = en_admin_questionnaire_editor_other_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Other_HintInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_other_hint = en_admin_questionnaire_editor_other_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Other_HintInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_other_hint = en_admin_questionnaire_editor_other_hint;

/**
* | output |
* | --- |
* | "This will add a text field where members can enter a custom answer." |
*
* @param {Admin_Questionnaire_Editor_Other_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_other_hint = /** @type {((inputs?: Admin_Questionnaire_Editor_Other_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_Other_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_other_hint(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_other_hint(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_other_hint(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_other_hint(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_other_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_other_hint(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_other_hint(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_other_hint(inputs)
	return ro_admin_questionnaire_editor_other_hint(inputs)
});
export { admin_questionnaire_editor_other_hint as "admin.questionnaire_editor.other_hint" }